const PATH = "/api/v2/stay";

const ENDPOINTS = {
  V2_STAY_BOOKINGS: "/bookings/",
};

export type BookingV2Endpoints = keyof typeof ENDPOINTS;
export const BookingV2Collection = { PATH, ENDPOINTS };
